import { IconWrapper } from '../runtime';
export default IconWrapper('calendar-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("g", [h("g", {
    "attrs": {
      "filter": 'url(#' + props.id + '48c00c7d' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'e34e51b2' + ')'
    }
  })]), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19.202 6.49991C19.202 5.67148 18.5304 4.99991 17.702 4.99991H6.302C5.47357 4.99991 4.802 5.67148 4.802 6.49991V9.20255H19.202V6.49991ZM9.77393 6.60208C9.67752 6.60208 9.59937 6.68024 9.59937 6.77665V7.22751C9.59937 7.32392 9.67752 7.40208 9.77393 7.40208H14.2248C14.3212 7.40208 14.3994 7.32392 14.3994 7.22751V6.77665C14.3994 6.68024 14.3212 6.60208 14.2248 6.60208H9.77393Z",
      "fill": "white",
      "fill-opacity": "0.7"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19.202 9.20255H4.802V17.9008C4.802 18.7292 5.47357 19.4008 6.302 19.4008H17.702C18.5304 19.4008 19.202 18.7292 19.202 17.9008V9.20255ZM9.59937 10.8432C9.59937 10.7655 9.66233 10.7025 9.73999 10.7025H14.2587C14.3364 10.7025 14.3994 10.7655 14.3994 10.8432V10.8823C14.4001 10.8871 14.4005 10.8922 14.4005 10.8973V11.987C14.4005 11.9955 14.4001 12.004 14.3994 12.0125V12.0623C14.3994 12.115 14.3704 12.1609 14.3275 12.185L14.3165 12.1975C14.0282 12.5071 13.0753 13.5792 12.6948 14.6135C12.337 15.5863 12.2584 16.52 12.2413 16.864C12.2374 16.9412 12.1741 17.0029 12.0968 17.0029H10.5613C10.4762 17.0029 10.4112 16.9283 10.4254 16.8443C10.4857 16.4893 10.663 15.5852 11.042 14.6135C11.4914 13.4615 11.7912 13.0814 12.3611 12.3586L12.4837 12.2029H9.73999C9.66233 12.2029 9.59937 12.14 9.59937 12.0623V10.8432Z",
      "fill": "white"
    }
  })]), h("defs", [h("filter", {
    "attrs": {
      "id": props.id + '48c00c7d',
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [h("feFlood", {
    "attrs": {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "result": "shape"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), h("feOffset", {
    "attrs": {
      "dy": "-0.75"
    }
  }), h("feComposite", {
    "attrs": {
      "in2": "hardAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in2": "shape",
      "result": "effect1_innerShadow_913_633"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + 'e34e51b2',
      "x1": "24",
      "y1": "23.25",
      "x2": "1.34669e-06",
      "y2": "0.750001",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#3E45EB"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5A92FF"
    }
  })])])]);
});